import styled from 'styled-components';

export const HeaderStyle = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 1024px) {
    width: 66.2%;
    height: 100%;
  }

  .header__wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin: 10px;

    @media (min-width: 1024px) {
      height: 100vh;
      justify-content: center;
    }

    .logo-box {
      display: none;
      justify-content: center;

      @media (min-width: 1024px) {
        display: none;
      }
      .logo {
        max-width: 210px;
        height: 100%;
      }
    }

    .video-box {
      display: flex;
      justify-content: center;
      @media (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .video {
        width: 100%;
        height: 100%;
        @media (max-width: 1024px) {
          width: 90%;
          height: 100%;
        }
      }
    }

    .img-box {
      display: flex;
      justify-content: center;

      @media (max-width: 1023px) {
        display: none;
      }
      .media {
        max-width: 650px;
        width: 90%;
        height: 100%;
        max-width: 550px;
      }
    }
  }
`;
